<template>
  <div>

    <b-breadcrumb :items="$options.breadcrumb"/>

    <div class="d-flex align-items-center justify-content-between">
      <h2>Modellen</h2>
      <b-btn variant="success" @click="showCreate = true">
        <span class="mdi mdi-plus-thick" /> Model toevoegen
      </b-btn>
    </div>
    <table-wrap :query="$options.query" small :fields="$options.fields" selectable @row-selected="onModelSelect">
      <template #cell(selected)="data">
        <b-form-checkbox :checked="data.rowSelected"/>
      </template>
      <template v-slot:cell(actions)="row">
        <b-btn size="sm" variant="danger" @click="deleteModel(row)"><span class="mdi mdi-trash-can"/> Verwijderen</b-btn>
        <b-btn size="sm" variant="primary" @click="edit = row.item.id" class="ml-1"><span class="mdi mdi-pencil"/> Bewerken</b-btn>
      </template>
      <template v-slot:cell(detectOk)="row">
        <span v-if="row.value" class="text-success"><span class="mdi mdi-check"/> OK</span>
        <span v-else class="text-danger"><span class="mdi mdi-close" /> Niet OK</span>
      </template>
      <template v-slot:cell(profileOk)="row">
        <span v-if="row.value" class="text-success"><span class="mdi mdi-check"/> OK</span>
        <span v-else class="text-danger"><span class="mdi mdi-close" /> Niet OK</span>
      </template>
      <template #custom-foot>
        <b-tr>
          <b-td class="p-1 pl-2 text-center"><b-icon icon="arrow-return-right"/></b-td>
          <b-td colspan="8" class="p-1">
            <b-btn size="sm" @click="showMassUpdate = !showMassUpdate">Mass update</b-btn>
          </b-td>
        </b-tr>
      </template>
    </table-wrap>

    <b-modal title="Nieuw model" v-model="showCreate" centered no-close-on-backdrop title-class="font-weight-bold">
      <edit-model ref="createModel"/>
      <template v-slot:modal-footer="{ok, cancel}">
        <b-btn @click="cancel">Annuleer</b-btn>
        <b-btn @click="$refs.createModel.create(ok)" variant="primary">Opslaan</b-btn>
      </template>
    </b-modal>

    <b-modal title="Model bewerken" v-model="showEdit" centered>
      <edit-model :id="edit" ref="editModel" />
      <template v-slot:modal-footer="{ok, cancel}">
        <b-btn @click="cancel">Annuleer</b-btn>
        <b-btn @click="$refs.editModel.saveEdit(ok)" variant="primary">Opslaan</b-btn>
      </template>
    </b-modal>

    <b-modal title="Mass update" v-model="showMassUpdate" centered>
      <mass-update-model ref="massModel" :ids="selectedModels.map(({id}) => id)" />
      <template v-slot:modal-footer="{ok, cancel}">
        <b-btn @click="cancel">Annuleer</b-btn>
        <b-btn @click="$refs.massModel.save(ok)" variant="primary">Opslaan</b-btn>
      </template>
    </b-modal>

  </div>
</template>

<script>
import TableWrap from '@/components/TableWrap';
import EditModel from '@/components/EditModel';
import MassUpdateModel from '@/components/MassUpdateModel';
export default
{
    components: {TableWrap, EditModel, MassUpdateModel},
    computed:
    {
        showEdit:
        {
            get() { return this.edit !== null },
            set(val) { this.edit = val ? this.edit : null }
        }
    },
    data()
    {
        return {
            edit: null,
            selectedModels: [],
            showCreate: false,
            showMassUpdate: false
        }
    },
    methods:
    {
        onModelSelect(selection)
        {
            this.selectedModels = selection;
        },
        async deleteModel(row)
        {
            const response = await this.$bvModal.msgBoxConfirm('Ben je zeker dat je dit wil verwijderen?',
                {
                    title: 'Model verwijderen',
                    okTitle: 'Verwijder',
                    okVariant: 'danger',
                    centered: true,
                    cancelTitle: 'Niet verwijderen',
                    cancelVariant: 'info'
                }
            );

            if (!response)
                return;

            return this.$apollo.mutate(
                {
                    mutation: require('../../graphql/mutation/delete_model.gql'),
                    variables: {id: row.item.id}
                }
            );
        }
    },
    query: require('../../graphql/live/admin_list_models.gql'),
    fields:
    [
        {
            key: 'selected',
            label: '',
            tdClass: 'p-1',
            selectAll: true,
            thClass: 'p-0',
        },
        {
            key: 'brand.name',
            label: 'Merk',
            search: 'STRING'
        },
        {
            key: 'name',
            label: 'Naam',
            search: 'STRING'
        },
        {
            key: 'snmpName',
            label: 'SNMP naam',
            search: 'STRING'
        },
        {
            key: 'profile.name',
            label: 'Profiel naam',
            search: 'STRING',
            sortable: true,
            sort: 'PROFILE_BY_PROFILE_ID__NAME'
        },
        {
            key: 'detectOk',
            label: 'Detectie?',
            tdClass: 'text-nowrap'
        },
        {
            key: 'profileOk',
            label: 'Profiel?',
            tdClass: 'text-nowrap'
        },
        {
            key: 'printers.totalCount',
            label: 'In gebruik',
            sortable: true,
            sort: 'PRINTERS_BY_MODEL_ID__COUNT'
        },
        {
            key: 'actions',
            label: 'Acties',
            thClass: 'text-right',
            tdClass: 'text-right text-nowrap'
        }
    ],
    breadcrumb:
    [
        {text: 'Configuratie'},
        {text: 'Modellen'}
    ],
}
</script>

<style scoped>

</style>